<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { cn } from '@/lib/utils'

const VARIANT_CLASSES = {
  warning: 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200',
  danger: 'border-red-200 bg-red-50 text-red-800 dark:border-red-900 dark:bg-red-950/30 dark:text-red-400',
  success: 'border-green-200 bg-green-50 text-green-800 dark:border-green-800 dark:bg-green-950/40 dark:text-green-300',
  info: 'border-blue-200 bg-blue-50 text-blue-800 dark:border-blue-800 dark:bg-blue-950/40 dark:text-blue-300',
} as const

const props = defineProps<{
  variant: keyof typeof VARIANT_CLASSES
  title?: string
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <Alert :class="cn(VARIANT_CLASSES[props.variant], props.class)">
    <slot name="icon" />
    <AlertTitle v-if="title" class="text-current">{{ title }}</AlertTitle>
    <AlertDescription class="text-current">
      <slot />
    </AlertDescription>
  </Alert>
</template>
